<div class="token-cancel-container">
  <a id="close-dialog" class="close-dialog" (click)="closeModal()">
    <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
  </a>
  <div class="title">
    Cancelar token
  </div>

  <div class="message mt-3">
    {{modalCancelTokenMessage}}
  </div>
  <div class="inputs-container mt-3 grid-error">
    <div>
      <code-input
        [isCodeHidden]="false"
        [codeLength]="6"
        (codeChanged)="onCodeChanged($event)"
        (codeCompleted)="onCodeCompleted($event)"
      >
      </code-input>
      <span *ngIf="errorCodeIntroduced">{{'Codigo de seguridad incorrecto' | translate}}</span>
    </div>
  </div>

<div class="btns-container mt-4">
  <button class="btn-outline-info btn resend-code" (click)="resendCodeEmail()" [disabled]="codeSent" >
    <ng-container *ngIf="resending; else resend">
      <div style="font-size: 1rem;">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{"Reenviando" | translate}}...
      </div>
    </ng-container >
    <ng-template #resend>
      <span style="font-size: 1rem;">{{'Reenviar codigo' | translate}}</span>
    </ng-template>


  </button>
  <button class="btn-primary btn" [disabled]="!validCode" (click)="validateCode()">

    <ng-container *ngIf="validating; else continue">
      <div style="font-size: 1rem;">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Validando...
      </div>
    </ng-container >
    <ng-template #continue>
      <span style="font-size: 1rem;">{{'Continuar' | translate}}</span>
    </ng-template>

  </button>

</div>
